export default "<svg viewBox=\"0 0 15 20\">\n        <path d=\"M 5,5 10,10 5,15 \" fill=\"none\" />\n      </svg>";